export function applyDetectedHumanLocation(report, zipCode, locationH3) {
  report.zip = zipCode;
  report.locationH3 = locationH3 || null;
}

export function canApplyDetectedHumanLocation(report, expectedZipCode) {
  return report.zip === expectedZipCode;
}

export function applyManualHumanZip(report, zipCode) {
  report.zip = zipCode;
  report.locationH3 = null;
}
